/**
 * Notes domain types.
 *
 * Shared by `services/storage/notesRepository.ts`, `stores/notesStore.ts`
 * and `NotesPage`. Content is stored as plain Markdown — rendered with the
 * existing `components/chat/MarkdownRenderer` rather than a new rich-text
 * editor library. See `WORKSPACE_SYSTEM.md`.
 */

export interface NoteFolder {
  readonly id: string;
  workspaceId: string;
  parentId: string | null;
  name: string;
  readonly createdAt: number;
}

export interface Note {
  readonly id: string;
  workspaceId: string;
  folderId: string | null;
  title: string;
  content: string;
  tags: string[];
  pinned: boolean;
  readonly createdAt: number;
  updatedAt: number;
}

/** Lightweight list-view shape — avoids loading every note's full body. */
export interface NoteSummary {
  readonly id: string;
  workspaceId: string;
  folderId: string | null;
  title: string;
  /** First ~140 chars of `content`, for list previews. */
  excerpt: string;
  tags: string[];
  pinned: boolean;
  readonly createdAt: number;
  updatedAt: number;
}

export interface NoteVersion {
  readonly id: string;
  readonly noteId: string;
  readonly content: string;
  readonly createdAt: number;
}

export interface NoteLink {
  readonly id: string;
  readonly fromNoteId: string;
  readonly toNoteId: string;
  readonly createdAt: number;
}

export interface NoteAttachment {
  readonly id: string;
  readonly noteId: string;
  fileName: string;
  /** Path relative to the active root's `Notes/attachments` folder. */
  filePath: string;
  mimeType: string;
  readonly createdAt: number;
}

/** Version-history retention — oldest snapshots beyond this are pruned. */
export const NOTE_VERSION_LIMIT = 20;
